package settings.diagnosisSetting.components

import antd.form.form
import antd.form.formItem
import antd.icon.checkOutlined
import antd.icon.closeOutlined
import antd.input.input
import antd.message.message
import antd.modal.modal
import antd.select.SelectComponent
import antd.select.optGroup
import antd.select.option
import antd.select.select
import antd.switch.switch
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.orm.mapping.SignSymptomSetting
import ext.isNumber
import external.select.filterOptionFun
import kotlinext.js.Object
import kotlinext.js.js
import org.w3c.dom.events.MouseEvent
import react.*
import react.dom.attrs
import react.dom.div
import react.dom.jsStyle
import react.dom.span
import kotlin.reflect.KMutableProperty1

external interface SignSymptomSettingModalProps : RProps {
  var visibility:Boolean?
  var updateVisibility:(Boolean)->Unit
  var currentSetting:SignSymptomSetting
  var getAvailableSignSymptoms:(diagnosisSettingId:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<Array<com.jingfangpai.common.data.model.CascadedOption<String>>>) -> Unit, errorCallback: (exception:Throwable) -> Unit) -> Unit
  var saveSetting:(signSymptom:com.jingfangpai.common.orm.mapping.SignSymptomSetting, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.SignSymptomSetting>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
  var onSaved:(savedSetting: SignSymptomSetting)->Unit
  var currentSignSymptomName:String?

}

data class SignSymptomSettingModalContextData(var placeHolderFunction: (param: String) -> Unit)

val SignSymptomSettingModal = functionalComponent<SignSymptomSettingModalProps> { props ->

    //val ctx = useContext(SignSymptomSettingModalPageContext)
    val (availableSignSymptoms,setAvailableSignSymptoms) = useState<Array<CascadedOption<String>>>(arrayOf())
    val (editingSetting,setEditingSetting) = useState(props.currentSetting)
    val (statusMessage,setStatusMessage) = useState("")

    fun updateField(property: KMutableProperty1<SignSymptomSetting, *>, value:dynamic, property2: KMutableProperty1<SignSymptomSetting, *>? = null, value2:dynamic?=null, property3: KMutableProperty1<SignSymptomSetting, *>? = null, value3:dynamic?=null){
        val _form = Object.assign(SignSymptomSetting(),editingSetting)
        property.set(_form,value)
        if(property2 != null){
            property2.set(_form,value2)
        }
        if(property3 != null){
            property3.set(_form,value3)
        }
        setEditingSetting(_form)
    }

    fun validateForm():Boolean{
        if(editingSetting.diagnosisSettingId.isNullOrBlank()){
            setStatusMessage("设置ID不可为空")
            return false;
        }
        if(editingSetting.signSymptomId.isNullOrBlank()){
            setStatusMessage("请选择症状")
            return false;
        }
        if(editingSetting.weight == null){
            setStatusMessage("请填写使用次序")
            return false;
        }
        return true
    }

    fun onSave(){
        if(validateForm()){
            setStatusMessage("保存中，请稍候...")
            props.saveSetting(editingSetting,{ resp->
                if(resp.ok()){
                    setStatusMessage("保存成功！")
                    setEditingSetting(resp.data!!)
                    props.onSaved(resp.data!!)
                }else{
                    setStatusMessage("保存失败：${resp.message}")
                }
            },{
                setStatusMessage("保存失败：${it.message}")
            })
        }

    }

    useEffect(props.currentSetting) {
        if(props.currentSetting != null){
            setEditingSetting(props.currentSetting)
            if(props.currentSetting.id.isNullOrBlank() && !props.currentSetting.diagnosisSettingId.isNullOrBlank()){
                //获取可新增的症状
                props.getAvailableSignSymptoms(props.currentSetting.diagnosisSettingId!!,{ resp->
                    if(resp.ok()){
                        setAvailableSignSymptoms(resp.data!!)
                    }else{
                        message.error("获取体征症状失败:${resp.message}")
                    }
                },{
                    message.error("获取体征症状失败:${it.message}")
                })
            }
        }
    }

    useEffectOnce {
    }

    modal {
        attrs{
            title = if(editingSetting.id.isNullOrBlank()) "添加症状" else "编辑症状"
            visible = props.visibility
            onCancel = {
                props.updateVisibility(false)
            }
            onOk = {
                onSave()
            }
        }
        div{
            form {
                attrs{
                    layout = "horizontal"
                }

                formItem {
                    attrs{
                        label = "说明"
                    }
                    +"此设置将决定症状在诊查向导中的使用"
                }

                formItem{
                    attrs{
                        label = "体征症状"
                    }
                    if(editingSetting.id.isNullOrBlank()) {
                        select<String, SelectComponent<String>> {
                            attrs {
                                mode = "default"
                                showSearch = true
                                labelInValue = false
                                value = editingSetting.signSymptomId
                                placeholder = "选择症状"
                                optionLabelProp = "label"
                                filterOption = ::filterOptionFun
                                //onSearch = fetchUser
                                onChange = { selected: String, any: Any ->
                                    console.log("select value", selected);
                                    updateField(SignSymptomSetting::signSymptomId, selected)
                                }
                                style = js { width = "100%" }
                            }
                            availableSignSymptoms.forEach { optGroup ->
                                optGroup {
                                    attrs {
                                        label = "${optGroup.label}"
                                    }
                                    optGroup.children?.forEach { opt ->
                                        option {
                                            attrs {
                                                label = "${opt.label}"
                                                value = "${opt.value}"
                                            }
                                            +"${opt.label}"
                                        }
                                    }
                                }
                            }
                        }
                    }else{
                        span{
                            +"${props.currentSignSymptomName?:""}"
                        }
                    }
                }
                formItem{
                    attrs{
                        label = "仅医生使用"
                    }
                    switch {
                        attrs{
                            checkedChildren = buildElement {
                                checkOutlined {  }
                            }
                            unCheckedChildren = buildElement {
                                closeOutlined {  }
                            }
                            defaultChecked = editingSetting.isDoctorOnly
                            onChange = { checked: Boolean, mouseEvent: MouseEvent ->
                                updateField(SignSymptomSetting::isDoctorOnly,checked)
                            }
                        }
                    }
                }
                formItem{
                    attrs{
                        label = "存在时建议"
                    }
                    input {
                        attrs {
                            value = editingSetting.suggestion
                            onChange = {event: dynamic ->
                                updateField(SignSymptomSetting::suggestion,event.target.value as String)
                            }
                        }
                    }
                }
                formItem{
                    attrs{
                        label = "代表存在的问题"
                    }
                    input {
                        attrs {
                            value = editingSetting.questionForYes
                            onChange = {event: dynamic ->
                                updateField(SignSymptomSetting::questionForYes,event.target.value as String)
                            }
                        }
                    }
                }
                formItem{
                    attrs{
                        label = "代表不存在的问题"
                    }
                    input {
                        attrs {
                            value = editingSetting.questionForNo
                            onChange = {event: dynamic ->
                                updateField(SignSymptomSetting::questionForNo,event.target.value as String)
                            }
                        }
                    }
                }
                formItem{
                    attrs{
                        label = "代表轻度的问题"
                    }
                    input {
                        attrs {
                            value = editingSetting.questionForMild
                            onChange = {event: dynamic ->
                                updateField(SignSymptomSetting::questionForMild,event.target.value as String)
                            }
                        }
                    }
                }
                formItem{
                    attrs{
                        label = "代表中度严重的问题"
                    }
                    input {
                        attrs {
                            value = editingSetting.questionForModerate
                            onChange = {event: dynamic ->
                                updateField(SignSymptomSetting::questionForModerate,event.target.value as String)
                            }
                        }
                    }
                }
                formItem{
                    attrs{
                        label = "代表严重的问题"
                    }
                    input {
                        attrs {
                            value = editingSetting.questionForSerious
                            onChange = {event: dynamic ->
                                updateField(SignSymptomSetting::questionForSerious,event.target.value as String)
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "使用次序"
                    }
                    input {
                        attrs {
                            type = "number"
                            value = editingSetting.weight ?:1
                            placeholder = "请填写排序位置"
                            onChange = {event: dynamic ->
                                var str = event.target.value as String;
                                if (!str.isNullOrBlank() && str.isNumber()) updateField(SignSymptomSetting::weight, str.toInt()) else updateField(SignSymptomSetting::weight, null)
                            }
                        }
                    }
                }
                if(!statusMessage.isNullOrBlank()){
                    formItem{
                        span {
                            this.attrs{
                                jsStyle = js{
                                    color = "red"
                                }
                            }
                            +statusMessage
                        }
                    }
                }
            }
        }
    }
}
